// src/HR/Assign_Course/dialogs/MaxAttemptsDialog.jsx
import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    DialogContentText,
    Box,
    Typography,
} from '@mui/material';
import { Error as ErrorIcon } from '@mui/icons-material';

const MaxAttemptsDialog = ({
    open,
    onClose,
    data,
    onViewAttempts,
    isMobile,
}) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            sx={{ borderRadius: '12px' }}
        >
            <DialogTitle
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    borderBottom: '1px solid #E7E8E9',
                    padding: '10px 24px',
                }}
            >
                <Box display="flex" alignItems="center" gap={1}>
                    <Typography variant="h6">
                        Maximum Attempts Reached
                    </Typography>
                </Box>
            </DialogTitle>

            <DialogContent className="my-4">
                <Box textAlign="center" mb={3}>
                    <ErrorIcon
                        sx={{
                            width: 60,
                            height: 60,
                            color: '#dc2626',
                            mb: 2,
                        }}
                    />

                    <DialogContentText
                        sx={{
                            whiteSpace: 'pre-line',
                            color: 'text.primary',
                            textAlign: 'center',
                        }}
                    >
                        {data?.error ||
                            "Maximum attempts reached for few users.\nThis exam cannot be assigned again."}
                    </DialogContentText>
                </Box>
            </DialogContent>

            <DialogActions
                sx={{
                    padding: '1rem',
                    borderTop: '1px solid #E7E8E9',
                    justifyContent: 'flex-end',
                    gap: 1,
                }}
            >
                <button className="btn-negative" onClick={onClose}>
                    Close
                </button>
            </DialogActions>
        </Dialog>
    );
};

export default MaxAttemptsDialog;